import { upperFirst } from 'lodash'
import moment from 'moment'

export function formatMeetingDuration(startUTC: string, endUTC: string, locale: string): string {
  const start = moment.utc(startUTC).local()
  const end = moment.utc(endUTC).local()

  return `${start.locale(locale).format('LT')} - ${end.locale(locale).format('LT')}`
}

export function formatDateToString(isoUTC: string, locale: string): string {
  const m = moment.utc(isoUTC).local()

  const date = m.locale(locale).format('LL')
  return upperFirst(date)
}

export function formatDateTimeToString(isoUTC: string, locale: string): string {
  const m = moment.utc(isoUTC).local()
  return m.locale(locale).format('LLL')
}
